"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RejectResolutionDto = exports.CoreGetDisputesQueryDto = exports.CoreCreateDisputeDto = void 0;
// Note: Validation decorators should be added in backend services, not here
// This is a shared DTO used by both frontend and backend
// reason is only set when rejecting a resolution (reject-resolution endpoint), not on create
class CoreCreateDisputeDto {
    projectMilestoneId;
    disputeType;
    describeIssue;
    expectation; // Optional: if not provided, will use describeIssue
    desiredOutcome;
}
exports.CoreCreateDisputeDto = CoreCreateDisputeDto;
class CoreGetDisputesQueryDto {
    projectId;
    projectMilestoneId;
    status;
    relations;
}
exports.CoreGetDisputesQueryDto = CoreGetDisputesQueryDto;
/** Used when rejecting a resolution (reject-resolution endpoint). Validation decorators applied in API layer. */
class RejectResolutionDto {
    reason;
}
exports.RejectResolutionDto = RejectResolutionDto;
